import Banner from "../components/Banner";
import { FAQ, FAQList, FAQItem } from "../components/FAQ";
import RegisterCallout from "../components/RegisterCallout";
import { Link } from "react-router-dom";

export default function PageFAQ() {
  return (
    <>
      <Banner className="bg-white-after">
        <div className="col-12 mb-3">
          <div className="display-1 color-white">
            Frequently Asked Questions
          </div>
        </div>
        <div className="col-12 col-md-9 col-lg-8 col-xl-7 mb-2">
          <p className="color-white mb-0">
            Please don&apos;t hesitate to{" "}
            <a className=" color-white" href="mailto:fincomp@balancedcomp.com">
              email us
            </a>{" "}
            with any questions. A member of our team will reach out to you
            within 48 hours.
          </p>
        </div>
      </Banner>

      <FAQ className="bg-white">
        <FAQList>
          <FAQItem question="How do I register?">
            {/* <p>
              Use the following{" "}
              <Link to="/Registration">registration form.</Link>. Every attendee
              must register personally, including those in groups.
            </p> */}
            FinComp '27 registration is now open through August 31, 2027
            available <Link to="/Registration">here</Link>. Those who register
            by June 1, 2023 will also:
            <ul>
              <li> Benefit from the early-bird discounted conference rate!</li>
              <li>
                Receive automatic eligibility to win a free ticket to see
                Beyonce live in concert (from the comfort of a booth) on 9/18
                with the BalancedComp team!
              </li>
            </ul>
            Early-bird limited event pricing is valid for those who register
            before June 1, 2023, where the price will return to the standard
            general admission cost of $1,295 per registrant. Please use{" "}
            <a href="#">this link</a> to make your hotel reservation at the
            Hotel Kansas City. To make your reservation with any extended dates,
            please call the Hotel Kansas City at (816) 895-0421 and identify
            yourself as a FinComp '27 attendee.
          </FAQItem>

          <FAQItem question="How do I become a sponsor?">
            <p>
              Learn more on the{" "}
              <Link to="/Sponsors">Sponsorship Opportunities</Link> page. If
              you'd like to become a sponsor, you can apply{" "}
              <Link to="/SponsorForm"> here</Link>.
            </p>
          </FAQItem>

          <FAQItem question="How will this conference benefit me?">
            <p>
              <strong>Personal & Professional Development:</strong> Tailored
              specifically for HR professionals and executives within banks and
              credit unions, FinComp paves a fast-track platform to equip and
              empower you to navigate complex compensation challenges with
              confidence. Here, you'll gain:
            </p>
            <ul>
              <li>Expertise & Connections</li>
              <li>Exclusive industry market data</li>
              <li>Thought leadership</li>
              <li>Competitive Advantage</li>
              <li>Return on investment</li>
            </ul>
          </FAQItem>

          <FAQItem question="Is FinComp accredited?">
            <p>
              Yes, FinComp '25 is a fully SHRM and HRCI-accredited event. Not
              only will you be surrounded by some of the industry's leading
              experts and resources, you can now also earn up to 20 credit hours
              to apply directly to any of the following HRCI® certifications:
            </p>

            <ul>
              <li>aPHR™ | aPHRi™</li>

              <li>PHR® | PHRca®</li>

              <li>SPHR®</li>

              <li>GPHR®</li>

              <li>PHRi™</li>

              <li>SPHRi™</li>
            </ul>
          </FAQItem>

          <FAQItem question="Where can I find hotel information for FinComp? Is there a discounted hotel rate?">
            <p>
              You can find detailed information about the Estancia La Jolla
              Hotel & Spa on the <Link to="/Hotel">Fincomp Venue page</Link> or
              by visiting the{" "}
              <a
                href="https://www.estancialajolla.com/"
                target="_blank"
                rel="noreferrer"
              >
                hotel's website
              </a>
              .
            </p>

            <p>
              <a
                href="https://be.synxis.com/?adult=1&arrive=2025-09-07&chain=11910&child=0&currency=USD&depart=2025-09-10&group=7901519&hotel=12323&level=hotel&locale=en-US&productcurrency=USD&rooms=1"
                target="_blank"
                rel="noreferrer"
              >
                Book your room
              </a>{" "}
              before August 7, 2025, to guarantee the event’s discounted hotel
              rate of $329 + taxes/fees for this event! The FinComp-exclusive
              rate will automatically apply to your reservation using the link
              above.
            </p>

            <p>
              Detailed, step-by-step instructions for how to make your hotel
              reservations can be found{" "}
              <a
                href="https://scribehow.com/shared/FinComp_2025_Instructions_for_booking_a_hotel_room_at_Estancia_La_Jolla_Hotel_and_Spa__YF7_QEhUQ9WcdFN7J33Ouw?referrer=workspace"
                target="_blank"
                rel="noreferrer"
              >
                here
              </a>
              .
            </p>

            <p>
              Looking to extend your stay? The discounted group rate is valid
              for check-in and check-out dates between September 4-12th, based
              on room availability!
            </p>

            <p>
              FinComp ‘27 hotel guests will also receive these added perks per
              room:
            </p>

            <ul>
              <li>
                20% discount + free Hydrating Foot Treatment for any spa
                services booked from Sep. 6-10th!
              </li>
              <li>
                1 free hour per room/day on local e-bikes, upon reservation
              </li>
              <li>
                Welcome gift of 2 complimentary (refillable) aluminum water
                bottles{" "}
              </li>
              <li>In-room gourmet coffee and tea</li>
              <li>Unlimited premium wireless internet in guestrooms</li>
              <li>Fitness center access</li>
              <li>Weekend yoga and sound bath sessions</li>
              <li>Self-Guided beach hike</li>
              <li>
                Twenty-four (24) hour computer access and airline
                check-in/boarding pass printing capabilities
              </li>
              <li>Unlimited toll-free and local phone calls</li>
              <li>A closet of board games and a library</li>
              <li>
                Local attraction ticket discounts (see concierge for details)
              </li>
            </ul>

            <p>
              For any other questions, please email{" "}
              <a href="mailto:fincomp@balancedcomp.com">
                fincomp@balancedcomp.com
              </a>
              .
            </p>
          </FAQItem>

          <FAQItem question="Who should attend this event?">
            <p>
              Stay up-to-date on industry trends: Conferences are an excellent
              opportunity to learn about the latest industry trends and
              developments in your field. From keynote speakers to breakout
              sessions, FinComp offers a variety of opportunities to gain
              understanding of the latest market trends, best practices,
              emerging technologies, new market research, and benchmark data.
            </p>
            <ul>
              <li>
                <strong>Network with peers and industry leaders:</strong>{" "}
                Conferences bring together professionals from across your
                industry, providing a unique opportunity to meet and network
                with peers and industry leaders. You can connect with financial
                market experts, partners, mentors, and colleagues who can help
                you grow your career or business contribution.
              </li>
              <li>
                <strong>Gain new insights and transferable skills:</strong>{" "}
                FinComp offers a range of sessions and workshops that will help
                you develop new skills and knowledge. You'll learn about comp
                strategy, leadership, compensation law, and more. You can also
                leverage direct face-to-face opportunities with industry leaders
                to gain insight on specific challenges you might currently be
                facing.
              </li>
              <li>
                <strong>Promote your corporate brand:</strong> Attending FinComp
                can help you promote your business or personal brand. You're
                encouraged to participate in the group panel discussions, HR
                Roundtables, speaker Q&A sessions, meet our team, and network
                with other financial industry leaders.
              </li>
            </ul>
          </FAQItem>

          <FAQItem question="What should I know before I travel?">
            <p>
              After May 7, 2025, air travelers are required to show their Real
              IDs or passports during all domestic travel—traditional driver's
              licenses will not be accepted. Please be sure to bring either form
              of identification with you to the airport to avoid delays!
            </p>
          </FAQItem>

          <FAQItem question="Why should I attend this event?">
            <p>
              Stay up-to-date on industry trends: Conferences are an excellent
              opportunity to learn about the latest industry trends and
              developments in your field. From keynote speakers to breakout
              sessions, FinComp offers a variety of opportunities to gain
              understanding of the latest market trends, best practices,
              emerging technologies, new market research, and benchmark data.
            </p>
            <ul>
              <li>
                <strong>Network with peers and industry leaders:</strong>{" "}
                Conferences bring together professionals from across your
                industry, providing a unique opportunity to meet and network
                with peers and industry leaders. You can connect with financial
                market experts, partners, mentors, and colleagues who can help
                you grow your career or business contribution.
              </li>
              <li>
                <strong>Gain new insights and transferable skills:</strong>{" "}
                FinComp offers a range of sessions and workshops that will help
                you develop new skills and knowledge. You&apos;ll learn about
                comp strategy, leadership, compensation law and more. You can
                also leverage direct facetime opportunities with industry
                leaders to gain insight on specific challenges you might
                currently be facing.
              </li>
              <li>
                <strong>Promote your corporate brand:</strong> Attending FinComp
                can help you promote your business or personal brand.
                You&apos;re encouraged to participate in the group panel
                discussions, HR Roundtables, speaker Q&A sessions, meet our
                team, and network with other financial industry leaders.
              </li>
            </ul>
          </FAQItem>

          <FAQItem question="Can I bring additional guests to this event?">
            <p>
              The more, the merrier! Attendees are encouraged to experience
              FinComp individually or as a team, offering special group
              discounted pricing for those who wish to attend together. All
              registrants must submit their own registration form.
            </p>
          </FAQItem>

          <FAQItem question="What is the recommended dress attire?">
            <p>
              We love a good loungewear set as much as everyone else, but
              business casual is recommended for all conference sessions.
              Conference rooms can be chilly, so we advise wearing layers.
            </p>
            <p>
              Please note that scheduled meals (breakfast and lunch) will be
              buffet-style outdoors in the Garden Courtyard. On Monday evening,
              there will be an outdoor cocktail and networking mixer on the
              Olive Lawn from 4:30-6:30 PM. Business casual attire is
              recommended. Consider wearing flat or comfortable shoes suitable
              for walking on grass!
            </p>
          </FAQItem>

          <FAQItem question="What should I bring to this conference?">
            <p>
              Attendees will be provided with pens and notebooks. Laptops are
              not required, but are encouraged for notes. Digital copies of
              speaker slide decks will be distributed to all event registrants
              following the conference.
            </p>
          </FAQItem>

          <FAQItem question="How do I modify my registration?">
            <p>
              If you are a registered attendee and need to cancel or substitute
              your registration, please contact{" "}
              <a href="mailto:fincomp@balancedcomp.com">
                fincomp@balancedcomp.com.
              </a>{" "}
            </p>
            <p>
              Conference registrations may be canceled by emailing a written
              notification to{" "}
              <a href="mailto:fincomp@balancedcomp.com">
                fincomp@balancedcomp.com
              </a>{" "}
              no later than August 18, 2025. Cancellations received before
              August 18th will be charged a processing fee of $250.
              Cancellations received after August 18th and registrants who fail
              to provide a written cancellation notice within this timeframe
              will be responsible for forfeiting the full registration fee.
              BalancedComp assumes no liability for any nonrefundable travel,
              hotel, or other related expenses incurred by registrants.
            </p>
          </FAQItem>

          <FAQItem question="Any other questions?">
            <p>
              Feel free to email your questions to{" "}
              <a href="mailto:fincomp@balancedcomp.com">
                fincomp@balancedcomp.com
              </a>{" "}
              or BalancedComp's event manager, Laurie Touchberry, at{" "}
              <a href="mailto:LTT92688@gmail.com">LTT92688@gmail.com</a> or{" "}
              <a href="tel:949-266-4480">949-266-4480</a>.
            </p>
          </FAQItem>
        </FAQList>
      </FAQ>
      <RegisterCallout className="bg-before-white" />
    </>
  );
}
